import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { LoginGuard } from "../core/guards/login.guard";

import { CertificatesComponent } from "./certificates.component";
import { MailboxComponent } from "./mailbox/mailbox.component";
import { ListMailboxComponent } from "./mailbox/list-mailbox/list-mailbox.component";
import { DetailMailboxComponent } from "./mailbox/detail-mailbox/detail-mailbox.component";
import { ResquestCertificateDataComponent } from "./request/resquest-certificate-data/resquest-certificate-data.component";
import { ListQueryComponent } from "./query/list-query/list-query.component";
import { QueryComponent } from "./query/query.component";
import { RequestComponent } from "./request/request.component";
import { PwdExpiratedGuard } from "../core/guards/pwdExpirated";
import { ClearFiltersGuard } from "../core/guards/clear-filters.guard";

const routesCertificates: Routes = [
  {
    path: "",
    component: CertificatesComponent,
    canActivate: [LoginGuard, PwdExpiratedGuard],
    children: [
      {
        path: "buzon",
        component: MailboxComponent,
        children: [
          {
            path: "lista",
            component: ListMailboxComponent,
            canActivate: [ClearFiltersGuard],
          },
          {
            path: "detalle/:id",
            component: DetailMailboxComponent,
            data: {
              operation: "detail",
            },
          },
          {
            path: "edicion/:id",
            component: DetailMailboxComponent,
            data: {
              operation: "edit",
            },
          },
        ],
      },
      {
        path: "solicitud-certificado",
        component: RequestComponent,
        children: [
          {
            path: "datos",
            component: ResquestCertificateDataComponent,
          },
        ],
      },
      {
        path: "consulta",
        component: QueryComponent,
        children: [
          {
            path: "lista",
            component: ListQueryComponent,
            canActivate: [ClearFiltersGuard],
          },
          {
            path: "detalle/:id",
            component: DetailMailboxComponent,
            data: {
              operation: "detail",
              type: "NotHistory",
              url: "consulta",
            },
          },
          {
            path: "detalle/historico/:id",
            component: DetailMailboxComponent,
            data: {
              operation: "detail",
              type: "history",
              url: "consulta",
            },
          },
        ],
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routesCertificates)],
  exports: [RouterModule],
})
export class CertificatesRoutingModule {}
